module.exports = __webpack_public_path__ + "static/img/bg-tr.5d4d832f.png";